import React, { createContext, useContext, useEffect, useState } from "react";

const DeviceContext = createContext();

export const DeviceProvider = ({ children }) => {
  const [deviceInfo, setDeviceInfo] = useState({});

  useEffect(() => {
    function getDeviceInfo() {
        const userAgent = navigator.userAgent || "Unknown";
        const screenSize = `${window.screen.width}x${window.screen.height}`;
        const isTouchScreen = "ontouchstart" in window || navigator.maxTouchPoints > 0;
      
        // Device Type Detection
        const deviceType = /Mobi|Android|iPhone|iPad|iPod/.test(userAgent)
          ? "Mobile"
          : /Tablet|iPad/.test(userAgent)
          ? "Tablet"
          : "Desktop";
      
        // Detect OS using `navigator.userAgentData.platform` if available, else use `userAgent`
        let platform = "Unknown OS";
        if (navigator.userAgentData?.platform) {
          platform = navigator.userAgentData.platform;
        } else {
          if (/Windows/.test(userAgent)) platform = "Windows";
          else if (/Mac/.test(userAgent)) platform = "MacOS";
          else if (/Linux/.test(userAgent)) platform = "Linux";
          else if (/Android/.test(userAgent)) platform = "Android";
          else if (/iPhone|iPad|iPod/.test(userAgent)) platform = "iOS";
        }
      
        return {
          userAgent,
          platform,
          screenSize,
          isTouchScreen,
          deviceType,
        };
      }
      

    setDeviceInfo(getDeviceInfo());
  }, []);

  return (
    <DeviceContext.Provider value={deviceInfo}>
      {children}
    </DeviceContext.Provider>
  );
};

export const useDevice = () => useContext(DeviceContext);
